import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white flex flex-col justify-center items-center min-h-screen">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-[#F67E20]">404</h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-black md:text-4xl">{t('notfound.title')}</p>
          <p className="mb-4 text-lg font-light text-black">{t('notfound.description')}</p>
          <Link 
            to="/" 
            className="inline-flex text-white bg-[#F67E20] font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4"
          >
            {t('notfound.back')}
          </Link>
        </div>   
      </div>
    </section>
  );
};

export default NotFound;
